<template>
  <b-container v-if="deal.Hand.N !== null">
    <b-row v-if="overlay != null" class="text-center">
      <b-col class="ns">
        {{ overlay.N }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <template v-if="overlay != null">
          {{ overlay.TextualContract }}<br>
          Att: <span v-html="coloredLead"></span>
        </template>
      </b-col>
      <b-col>
        <hand :hand="deal.Hand.N" :lead="overlay != null ? overlay.Lead : -1"></hand>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-form-row v-if="overlay != null" class="ew">
      <b-col>
        {{ overlay.W }}
      </b-col>
      <b-col class="text-right EWEllipsis">
        {{ overlay.E }}
      </b-col>
    </b-form-row>
    <b-row>
      <b-col>
        <hand :hand="deal.Hand.W" :lead="overlay != null ? overlay.Lead : -1"></hand>
      </b-col>
      <b-col>
        <deal-status :number="dealNumber"></deal-status>
      </b-col>
      <b-col>
        <hand :hand="deal.Hand.E" :lead="overlay != null ? overlay.Lead : -1"></hand>
      </b-col>
    </b-row>
    <b-row v-if="overlay != null" class="text-center">
      <b-col class="ns">
        {{ overlay.S }}
      </b-col>
    </b-row>
    <b-row>
      <b-col></b-col>
      <b-col>
        <hand :hand="deal.Hand.S" :lead="overlay != null ? overlay.Lead : -1"></hand>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <deal-analysis :analysis="deal.Analysis"></deal-analysis>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Hand from '@/components/display/Hand';
import DealAnalysis from "@/components/display/DealAnalysis";
import DealStatus from "./DealStatus";
import {addColorToSuite} from "@/lib/cardSuits";

export default {
  name: 'Deal',
  components: {DealStatus, DealAnalysis, Hand},
  props: {
    deal: {
      type: Object,
      required: true
    },
    dealNumber: {
      required: true
    },
    overlay: {
      type: Object
    }
  },
  computed: {
    coloredLead() {
      return addColorToSuite(this.overlay.TextualLead);
    }
  }
};
</script>

<style scoped>
.ns {
  color: #1d4ed8;
  font-weight: bold;
}

.ew {
  color: #dc2626;
  font-weight: bold;
}

.EWEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
